var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0611 12.354C17.9218 12.2146 17.7564 12.104 17.5743 12.0286C17.3923 11.9532 17.1971 11.9143 17.0001 11.9143C16.803 11.9143 16.6079 11.9532 16.4258 12.0286C16.2438 12.104 16.0784 12.2146 15.9391 12.354L13.5001 14.793V6C13.5001 5.60218 13.342 5.22064 13.0607 4.93934C12.7794 4.65804 12.3979 4.5 12.0001 4.5C11.6022 4.5 11.2207 4.65804 10.9394 4.93934C10.6581 5.22064 10.5001 5.60218 10.5001 6V14.793L8.06107 12.354C7.7798 12.0726 7.39828 11.9145 7.00042 11.9144C6.60256 11.9143 6.22096 12.0722 5.93957 12.3535C5.65817 12.6348 5.50003 13.0163 5.49994 13.4141C5.49985 13.812 5.6578 14.1936 5.93907 14.475L9.52507 18.061C9.85008 18.386 10.2359 18.6439 10.6606 18.8198C11.0853 18.9957 11.5404 19.0863 12.0001 19.0863C12.4597 19.0863 12.9149 18.9957 13.3395 18.8198C13.7642 18.6439 14.1501 18.386 14.4751 18.061L18.0611 14.475C18.3423 14.1937 18.5002 13.8122 18.5002 13.4145C18.5002 13.0168 18.3423 12.6353 18.0611 12.354Z",
    fill: "#374957"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow_down.7ff9ad18fc594b80d34463097c2d8287.svg";
export { ForwardRef as ReactComponent };